import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Header from '../../components/layout/Header';
import PrimaryBox from '../../components/layout/PrimaryBox';
import FormHistoryTable from '../../components/tables/qhse/forms/FormHistoryTable';
import { usePageTitle } from '../../hooks/usePageTitle';
import { capitalizeFirstLetter } from '../../utils/capitalize';

const FormHistoryPage: React.FC = () => {
    const { t } = useTranslation();
    const { groupId } = useParams();

    usePageTitle(capitalizeFirstLetter(t('forms')));

    return (
        <PrimaryBox>
            <Header
                title={t('qhse')}
                breadcrumbs={[{ label: capitalizeFirstLetter(t('forms')), link: '/qhse/forms' }, { label: capitalizeFirstLetter(t('formHistory')) }]}
                subTitle={capitalizeFirstLetter(t('formHistory'))}
                isDateVisible={false}
            ></Header>
            <FormHistoryTable groupId={groupId || ''} />
        </PrimaryBox>
    );
};

export default FormHistoryPage;
